/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Certificate_IncludedInputs */

const en_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COA Included?`)
};

const es_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿COA incluido?`)
};

const fr_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificat d'authenticité inclus ?`)
};

const de_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echtheitszertifikat inklusive?`)
};

const ja_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真贋証明書(COA)の有無`)
};

const zh_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含鉴定证书 (COA)？`)
};

const ar_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل شهادة الأصالة (COA) مشمولة؟`)
};

const id_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termasuk COA?`)
};

const it_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificato di Autenticità Incluso?`)
};

const ru_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сертификат подлинности включен?`)
};

const pt_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificado (COA) Incluído?`)
};

const ko_field_certificate_included = /** @type {(inputs: Field_Certificate_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진품 증명서(COA) 포함 여부`)
};

/**
* | output |
* | --- |
* | "COA Included?" |
*
* @param {Field_Certificate_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_certificate_included = /** @type {((inputs?: Field_Certificate_IncludedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Certificate_IncludedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_certificate_included(inputs)
	if (locale === "es") return es_field_certificate_included(inputs)
	if (locale === "fr") return fr_field_certificate_included(inputs)
	if (locale === "de") return de_field_certificate_included(inputs)
	if (locale === "ja") return ja_field_certificate_included(inputs)
	if (locale === "zh") return zh_field_certificate_included(inputs)
	if (locale === "ar") return ar_field_certificate_included(inputs)
	if (locale === "id") return id_field_certificate_included(inputs)
	if (locale === "it") return it_field_certificate_included(inputs)
	if (locale === "ru") return ru_field_certificate_included(inputs)
	if (locale === "pt") return pt_field_certificate_included(inputs)
	return ko_field_certificate_included(inputs)
});